import { Outlet } from 'react-router-dom'

import Link from '@/components/link'
import Logo from '@/components/logo'

export default function AuthLayout() {
  return (
    <>
      <div className="w-screen relative flex h-screen items-center justify-center">
        <Link
          href="/"
          className="text-sm h-10 pl-2 pr-4 gap-0 font-semibold bg-slate-1 border-slate-1 text-slate-11 hover:bg-slate-5 hover:text-slate-12 focus-visible:ring-4 focus-visible:ring-slate-7 focus-visible:outline-none focus-visible:bg-slate-6 disabled:hover:bg-slate-1 inline-flex items-center border justify-center select-none rounded-full disabled:cursor-not-allowed disabled:opacity-70 transition ease-in-out duration-200 absolute left-0 top-6 md:left-6"
        >
          <svg
            fill="none"
            height={24}
            viewBox="0 0 24 24"
            width={24}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.25 8.75L9.75 12L13.25 15.25"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
            />
          </svg>
          返回主页
        </Link>
        <main className="mx-auto w-full max-w-[450px]">
          <div className="w-full flex-col justify-center px-3 sm:px-6 space-y-6">
            <Logo className="mx-auto block sm:mx-0" width={50} />
            <Outlet />
            <p className="text-xs text-slate-11 font-normal">
              点击继续，即表示您同意我们的{' '}
              <Link
                href="/terms-of-service"
                className="underline underline-offset-4 hover:text-primary"
              >
                用户使用条款
              </Link>{' '}
              和{' '}
              <Link
                href="/privacy-policy"
                className="underline underline-offset-4 hover:text-primary"
              >
                隐私政策
              </Link>
              。
            </p>
          </div>
        </main>
      </div>
    </>
  )
}
